interface CleanseLink {
    label: string
    path: string
}

export const cleanseLinkFor = (
    recordId: string,
    isImageCleansed: boolean | undefined,
): CleanseLink =>
    isImageCleansed
        ? { label: 'Cleanse', path: `/prereview/${recordId}` }
        : { label: 'Job moderation', path: `/job-moderation/${recordId}` }
